module.exports = __webpack_public_path__ + "static/media/vision_loss.dfcafc76.svg";